import { markTeamsAuthPopupSession,
  notifyTeamsAuthFailure,
  notifyTeamsAuthSuccess,
  TEAMS_AUTH_POPUP_STATE_KEY,
} from '@/utils/teams-auth';
import { resolveEnterpriseSsoOrganization } from '@/utils/auth0-organization';
import { markSsoSessionIntent } from '@/utils/sso-session-guard';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router-dom';

/** Loaded inside the Teams auth popup; redirects to Auth0 (top-level in popup). */
const TeamsAuthStartPage = () => {
  const { loginWithRedirect, isAuthenticated, isLoading, error } = useAuth0();
  const [searchParams] = useSearchParams();
  const started = useRef(false);
  const notified = useRef(false);
  const organization = resolveEnterpriseSsoOrganization({
    queryOrg: searchParams.get('org'),
  });

  useEffect(() => {
    if (error && !notified.current) {
      notified.current = true;
      console.error('Teams auth error:', error);
      notifyTeamsAuthFailure(error.message || 'Authentication failed');
      return;
    }

    if (isLoading) return;

    if (isAuthenticated) {
      if (!notified.current) {
        notified.current = true;
        notifyTeamsAuthSuccess();
      }
      return;
    }

    if (started.current) return;
    started.current = true;
    markTeamsAuthPopupSession();
    markSsoSessionIntent();

    loginWithRedirect({
      appState: { [TEAMS_AUTH_POPUP_STATE_KEY]: true },
      authorizationParams: {
        prompt: 'login',
        ...(organization ? { organization } : {}),
      },
    }).catch((redirectError) => {
      console.error('Teams auth start failed:', redirectError);
      notifyTeamsAuthFailure('Failed to start sign in');
    });
  }, [loginWithRedirect, isAuthenticated, isLoading, error, organization]);

  return (
    <div className="flex h-screen items-center justify-center">
      <p className="text-sm text-gray-600">Redirecting to sign in...</p>
    </div>
  );
};

export default TeamsAuthStartPage;
